import React from "react"
import Navbar from "../components/Navbar"
import { useParams } from "react-router-dom"
import Moment from "react-moment"
import {
  addDoc,
  collection,
  doc,
  setDoc,
  serverTimestamp,
} from "firebase/firestore"
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
  uploadBytes,
} from "firebase/storage"
import { db, storage } from "../firebase"
import { useAuth } from "../context/AuthContext"
import { useEffect, useState, useRef } from "react"
import {
  onSnapshot,
  updateDoc,
  query,
  where,
  getDoc,
  orderBy,
} from "firebase/firestore"

import ChatHeader from "../components/ChatHeader"
import { saveAs } from "file-saver"

function Chat() {
  const chatid = useParams()
  const [question, setquestion] = useState()
  const [messages, setmessages] = useState()
  const { currentUser } = useAuth()

  const [input, setinput] = useState()
  const [File, setFile] = useState()

  const sendMessage = async (e) => {
    const msgRef = collection(db, "chats", chatid.id, "messages")
    await addDoc(msgRef, {
      timestamp: serverTimestamp(),
      message: input,
      user: currentUser.email,
      photoURL: currentUser.photoURL,
    })

    const chatRef = doc(db, "chats", chatid.id)
    await setDoc(
      chatRef,
      {
        latestMessage: input,
        timestamp: serverTimestamp(),
      },
      { merge: true }
    )
    setinput("")
  }
  const uploadPicture = async (file) => {
    const storageRef = ref(storage, `images/${chatid.id}/${file.name}`)
    const uploadTask = await uploadBytes(storageRef, file)
    const starsRef = ref(storage, `images/${chatid.id}/${file.name}`)
    const name = file.name

    // Get the download URL
    await getDownloadURL(starsRef)
      .then(async (url) => {
        setFile(url)

        const msgRef = collection(db, "chats", chatid.id, "messages")
        await addDoc(msgRef, {
          timestamp: serverTimestamp(),
          url: url,
          message: name,
          user: currentUser.email,
          photoURL: currentUser.photoURL,
          type: "image",
        })
        const chatRef = doc(db, "chats", chatid.id)
        await setDoc(
          chatRef,
          {
            latestMessage: name,
            timestamp: serverTimestamp(),
          },
          { merge: true }
        )
        setFile("")
      })
      .catch((error) => {
        // A full list of error codes is available at
        // https://firebase.google.com/docs/storage/web/handle-errors
        switch (error.code) {
          case "storage/object-not-found":
            // File doesn't exist
            break
          case "storage/unauthorized":
            // User doesn't have permission to access the object
            break
          case "storage/canceled":
            // User canceled the upload
            break

          // ...

          case "storage/unknown":
            // Unknown error occurred, inspect the server response
            break
          default:
            break
        }
      })
  }
  const saveFile = (url, name) => {
    saveAs(url, "aries.pdf")
  }

  const fetchQuestions = async () => {
    const docRef = doc(db, "questions", chatid.id)
    const docSnap = await getDoc(docRef)

    if (docSnap.exists()) {
      setquestion(docSnap.data())
    }
  }
  useEffect(() => {
    fetchQuestions()
    const msgRef = collection(db, "chats", chatid.id, "messages")
    const q = query(msgRef, orderBy("timestamp", "asc"))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      setmessages(
        querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          timestamp: doc.data().timestamp?.toDate().getTime(),
        }))
      )
    })
    return unsubscribe
  }, [chatid.id])

  return (
    <div>
      <Navbar />
      {question && (
        <>
          <div className="body  max-w-7xl m-auto">
            <ChatHeader question={question} id={chatid.id} />

            <div className="chat_container">
              <div className="relative w-full p-6 ">
                {messages.length === 0 ? (
                  <>
                    <div
                      className="p-4 mb-4 text-sm text-blue-700 bg-blue-100 rounded-lg dark:bg-blue-200 dark:text-blue-800 justify-center"
                      role="alert"
                    >
                      <span className="font-medium">Welcome!</span> Please
                      describe your problem in details.
                    </div>
                  </>
                ) : null}
                {messages &&
                  messages.map((message) => (
                    <div key={message.id}>
                      <ul className="space-y-2">
                        {message.user === currentUser.email ? (
                          <li className="flex items-end">
                            <div className="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-2 items-start">
                              {!message.type ? (
                                <>
                                  You
                                  <span className="px-4 py-2 rounded-lg inline-block rounded-bl-none bg-blue-300 mt-2">
                                    <div>{message.message}</div>
                                  </span>
                                  <Moment fromNow>{message.timestamp}</Moment>
                                </>
                              ) : (
                                <div className="max-w-sm mt-2 rounded overflow-hidden shadow-lg ">
                                  <img
                                    className="w-full"
                                    src={message.url}
                                    alt={message.message}
                                  />
                                  <div className="px-6 py-4 mt-2 bg-blue-300 cursor-pointer ">
                                    <div
                                      className=" text-xl mb-2"
                                      onClick={() => {
                                        saveFile(message.url, message.name)
                                      }}
                                    >
                                      Click here to open {message.message}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>
                        ) : (
                          <li className="flex items-end justify-end">
                            <div className="flex flex-col space-y-2 text-xs max-w-xs mx-2 order-1 items-end">
                              {!message.type ? (
                                <>
                                  Dr Madhumita Mazumdar
                                  <span className="px-4 py-2 rounded-lg inline-block rounded-bl-none bg-gray-300 text-gray-600 mt-2">
                                    {message.message}
                                  </span>
                                  <Moment fromNow>{message.timestamp}</Moment>
                                </>
                              ) : (
                                <div className="max-w-sm rounded overflow-hidden shadow-lg mt-2">
                                  <img
                                    className="w-full"
                                    src={message.url}
                                    alt={message.message}
                                  />
                                  <div className="px-6 py-4 px-4 py-2 rounded-lg inline-block rounded-bl-none bg-gray-300 text-gray-600 mt-2 ">
                                    <div
                                      className=" text-xl mb-2 mt-2  cursor-pointer"
                                      onClick={() => {
                                        saveFile(message.url, message.name)
                                      }}
                                    >
                                      Click here to open {message.message}
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </li>
                        )}
                      </ul>
                    </div>
                  ))}
              </div>
            </div>
            {question.status && (
              <div className="send">
                <div className="flex items-center justify-between w-full p-3 border-t border-gray-300">
                  <label htmlFor="file">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 text-gray-500"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      onClick={() => {}}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13"
                      />
                    </svg>

                    <input
                      type="file"
                      id="file"
                      onChange={(e) => {
                        uploadPicture(e.target.files[0])
                      }}
                      className="hidden"
                    ></input>
                  </label>

                  <input
                    type="text"
                    placeholder="Enter Message Here"
                    className="block w-full py-2 pl-4 mx-3 bg-gray-100 rounded-full outline-none focus:text-gray-700"
                    name="message"
                    required
                    value={input}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        sendMessage()
                        setinput("")
                      }
                    }}
                    onChange={(e) => {
                      setinput(e.target.value)
                    }}
                  />

                  <button onClick={() => sendMessage()}>
                    <svg
                      className="w-5 h-5 text-gray-500 origin-center transform rotate-90"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path d="M10.894 2.553a1 1 0 00-1.788 0l-7 14a1 1 0 001.169 1.409l5-1.429A1 1 0 009 15.571V11a1 1 0 112 0v4.571a1 1 0 00.725.962l5 1.428a1 1 0 001.17-1.408l-7-14z" />
                    </svg>
                  </button>
                </div>
              </div>
            )}
            {!question.status && (
              <div
                className="flex p-4 mb-4 text-sm text-green-700 bg-green-100 rounded-lg dark:bg-green-200 dark:text-green-800"
                role="alert"
              >
                <svg
                  className="inline flex-shrink-0 mr-3 w-5 h-5"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                    clipRule="evenodd"
                  ></path>
                </svg>
                <div>
                  <div className="font-medium ">
                    Thank you for the opportunity to help and I wish you all the
                    best.
                  </div>
                  If you wish to talk to me again or have anymore doubts,please
                  feel free to ask another question
                </div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  )
}

export default Chat
